<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">
        {{ $t("Sales Book") }}
      </div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
                <!-- :disabled-dates="disabledDates" -->
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="text"
                  class="form-control"
                  v-model="customIndex"
                  @input="indexChange()"
                />
                <label :class="customIndex ? 'shift-up' : ''"
                  >Start Bill No</label
                >
              </div></div
            >
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getSalesBookRecordsReport((isExcel = 'N'))"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click.prevent="updateData()">
              Update Bill No
            </button>
          </div>
          <div
            class="col-lg-6 col-xl-2 align-self-center mb-3 font-weight-bold"
            v-if="getSalesBookRecords.length"
          >
            Last Bill No:{{
              +parseFloat(
                getSalesBookRecords[getSalesBookRecords.length - 1].bill_no_new
                  .split("-")
                  .slice(-1)
              )
            }}
          </div>

          <div
            v-if="getSalesBookRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getSalesBookRecordsReport((isExcel = 'Y'))"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x:scroll;width: auto !important"
        ref="exportable_table"
      >
        <table border="1" class="swc-report-table w-25 my-3">
          <tr>
            <td class="font-weight-bold bg-lightgrey">Month</td>
            <td class="font-weight-bold bg-lightgrey">Year</td>
          </tr>
          <tr>
            <td>{{ nepalMonth.month }}</td>
            <td>{{ nepalMonth.year }}</td>
          </tr>
        </table>

        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <th colspan="4">Invoice</th>
            <th></th>
          </thead>
          <thead class="bg-lightgrey font-weight-bold">
            <th>Date</th>
            <th>Bill No</th>
            <th>Bill No New</th>
            <th>Bill Type</th>
            <th>Total Sales</th>
          </thead>
          <tbody v-if="getSalesBookRecords.length > 0">
            <tr
              v-for="(salesBookData, salesBookDataIndex) in getSalesBookRecords"
              :key="salesBookDataIndex"
            >
              <td class="text-left">{{ salesBookData.bill_date }}</td>
              <td class="text-left">{{ salesBookData.bill_no }}</td>
              <td
                :class="
                  `text-left ${
                    salesBookData.bill_no !== salesBookData.bill_no_new
                      ? 'text-danger'
                      : ''
                  }`
                "
                >{{ salesBookData.bill_no_new }}</td
              >
              <td class="text-left">{{ salesBookData.type_of_product }}</td>
              <td class="text-right">
                {{ currFormat(salesBookData.total_amount_before_offer) }}
              </td>
            </tr>
            <tr class="bg-lightgrey font-weight-bold">
              <td class="text-left" colspan="4">Total</td>
              <td class="text-right">
                {{ currFormat(grandTotal.total_amount_grand_total) }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="11">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService-v2";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import _ from "lodash";
  import * as XLSX from "xlsx";

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        getSalesBookRecords: [],
        excelFilePath: "",
        nepalMonth: {},
        grandTotal: {},
        customIndex: 1,
        disabledDates: {
          from: "",
        },
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
    },
    watch: {
      // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      //   if (CinemaObj) {
      //     this.onSelectCinema(CinemaObj);
      //   }
      // },
      excelFilePath(value) {
        this.excelFilePath = value;
      },
      fromDate: function(value) {
        this.disabledDates.from = new Date(
          moment(this.fromDate).format("YYYY"),
          parseFloat(moment(this.fromDate).format("MM")),
          1
        );

        this.toDate = moment(this.toDate).isAfter(value, "months")
          ? moment(this.fromDate)
              .endOf("month")
              .format("YYYY-MM-DD")
          : this.toDate;
      },
    },
    mounted() {},
    methods: {
      moment,
      getCinemaList: function() {
        MasterService.GetCinemasByRoles()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
      },
      getSalesBookRecordsReport(isExcel) {
        if (isExcel == "N") {
          this.getSalesBookRecords = [];
        }
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isFix: true,
          isExcel,
        };
        ReportsService.getSalesBookReport(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.getSalesBookRecords = [...data.Records];

              //  order fix
              this.getSalesBookRecords.forEach((salesData, index) => {
                let splitBillNo = salesData.bill_no_new.split("-");
                splitBillNo[splitBillNo.length - 1] = (+parseFloat(
                  index + +parseFloat(this.customIndex)
                ))
                  .toString()
                  .padStart(6, 0);
                console.log(splitBillNo, index);
                salesData.bill_no_new = splitBillNo.join("-");
              });
              //  order fix

              this.grandTotal = { ...data.grandTotal };
              this.nepalMonth = { ...data.nepalMonth };
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
      indexChange: _.debounce(function(query) {
        this.getSalesBookRecordsReport("N");
      }, 600),
      updateData(Records = []) {
        if (Records.length) {
          ReportsService.salesBookFix({
            Records,
            cinema_id: this.dropDown.selectedCinemaId,
          }).then((response) => {
            const { data } = response;
            this.$toasted.show(data.message);
          });
        } else if (!Records.length) {
          ReportsService.salesBookFix({
            Records: this.getSalesBookRecords,
            cinema_id: this.dropDown.selectedCinemaId,
            last_bill_no: +parseFloat(
              this.getSalesBookRecords[
                this.getSalesBookRecords.length - 1
              ].bill_no_new
                .split("-")
                .slice(-1)
            ),
          }).then((response) => {
            const { data } = response;
            this.$toasted.show(data.message);
          });
        }
      },
    },
  };
</script>

<style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }

  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
  }
  .swc-report-table td {
    white-space: nowrap;
  }
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
  }
  .swc_table_header th {
    border: 1px solid black !important;
  }
  .no_border {
    border: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/salesBookReportFix.vue